<template>
  <div>
    <!-- Toolbar: toggle modalità filtro -->
    <v-toolbar flat dense color="transparent" class="mb-2">
      <v-btn-toggle v-model="modalita" mandatory dense borderless>
        <v-btn small value="anno" text>
          <v-icon small class="mr-1">mdi-calendar-year</v-icon>Anno
        </v-btn>
        <v-btn small value="range" text :disabled="!stagione_attiva || !stagione_attiva.id">
          <v-icon small class="mr-1">mdi-calendar-range</v-icon>Stagione
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-btn text small color="teal" class="mr-2" :disabled="!calendario" @click="dialog_analisi = true">
        <v-icon small class="mr-1">mdi-chart-box-outline</v-icon>
        Analisi
      </v-btn>
      <span class="text-caption grey--text">
        {{ settimane_filtrate.length }} settimane
      </span>
    </v-toolbar>

    <!-- Loading -->
    <v-row v-if="loading" align="center" justify="center" class="py-12">
      <v-progress-circular indeterminate color="green" width="2" />
    </v-row>

    <!-- Griglia settimane -->
    <v-row v-else-if="settimane_filtrate.length" dense>
      <v-col
        v-for="settimana in settimane_filtrate"
        :key="settimana.id"
        cols="12" sm="6" md="4" lg="3"
      >
        <SettimanaArriviCard
          :settimana="settimana"
          :fornitori="fornitori"
          @aggiungi-arrivo="onAggiungiArrivo"
          @apri-dettaglio="onApriDettaglio"
          @stampa-settimana="onStampaSettimana"
        />
      </v-col>
    </v-row>

    <!-- Stato vuoto -->
    <v-row v-else justify="center" class="py-12">
      <v-col class="text-center grey--text">
        <v-icon large color="grey lighten-2">mdi-calendar-blank-outline</v-icon>
        <div class="mt-2 text-caption">Nessun dato disponibile per questo periodo</div>
      </v-col>
    </v-row>

    <!-- Errore -->
    <v-alert v-if="errore" type="error" outlined dense class="ma-2">{{ errore }}</v-alert>

    <!-- Dialog aggiungi arrivo -->
    <AggiungiArrivoPiano
      v-model="dialog_aggiungi"
      :settimana="settimana_sel"
      :anno="anno_attivo"
      :fornitori="fornitori"
      :specie_disponibili="specie"
      :stagione_attiva="stagione_attiva"
    />

    <!-- Dialog dettaglio arrivo -->
    <DettaglioArrivoDialog
      v-model="dialog_dettaglio"
      :arrivo="arrivo_sel"
      :settimana="settimana_sel"
      :anno="anno_attivo"
      :specie_disponibili="specie"
      :fornitori="fornitori"
      :stagione_attiva="stagione_attiva"
    />

    <!-- Dialog analisi arrivi -->
    <AnalisiArriviDialog
      v-model="dialog_analisi"
      :anno="anno_attivo"
      :stagione_attiva="stagione_attiva"
    />
  </div>
</template>

<script>
import printer from "../../../service/printer";
import SettimanaArriviCard from "./SettimanaArriviCard.vue";
import AggiungiArrivoPiano from "./AggiungiArrivoPiano.vue";
import DettaglioArrivoDialog from "./DettaglioArrivoDialog.vue";
import AnalisiArriviDialog from "./AnalisiArriviDialog.vue";

export default {
  name: "CalendarioArriviTab",
  components: { SettimanaArriviCard, AggiungiArrivoPiano, DettaglioArrivoDialog, AnalisiArriviDialog },

  props: {
    // Oggetto stagione attiva: { anno, data_inizio, data_fine, ... }
    stagione_attiva: { type: Object, default: null },
  },

  data() {
    return {
      loading: false,
      errore: "",
      modalita: "anno",   // "anno" | "range"
      settimana_sel: null,
      arrivo_sel: null,
      dialog_aggiungi: false,
      dialog_dettaglio: false,
      dialog_analisi: false,
    };
  },

  watch: {
    anno_attivo: {
      immediate: true,
      handler(anno) {
        if (anno) this.caricaCalendario(anno);
      },
    },
  },

  computed: {
    anno_attivo() {
      if (!this.stagione_attiva) return new Date().getFullYear();
      return this.stagione_attiva.anno || new Date().getFullYear();
    },
    calendario() {
      return this.$store.getters.get_calendario_arrivi(this.anno_attivo);
    },
    fornitori() {
      return this.$store.getters.get_fornitori || [];
    },
    specie() {
      return this.$store.getters.get_specie || [];
    },

    settimane_filtrate() {
      if (!this.calendario?.settimane) return [];
      const settimane = [...this.calendario.settimane].sort((a, b) => a.numero - b.numero);
      if (this.modalita === "range" && this.stagione_attiva?.id) {
        const id_stagione = this.stagione_attiva.id;
        return settimane
          .map((s) => ({
            ...s,
            arrivi: (s.arrivi || []).filter((a) =>
              !a.stagioni || a.stagioni.includes(id_stagione)
            ),
          }))
          .filter((s) => s.arrivi.length > 0);
      }
      return settimane;
    },
  },

  methods: {
    async caricaCalendario(anno) {
      // Usa cache: non rifetcha se già in store
      if (this.$store.getters.get_calendario_arrivi(anno)) return;
      this.loading = true;
      this.errore = "";
      try {
        await this.$store.dispatch("fetch_calendario_arrivi", anno);
      } catch {
        this.errore = "Impossibile caricare il calendario per l'anno " + anno + ".";
      } finally {
        this.loading = false;
      }
    },

    onAggiungiArrivo(settimana) {
      this.settimana_sel = settimana;
      this.dialog_aggiungi = true;
    },

    onApriDettaglio({ arrivo, settimana }) {
      this.arrivo_sel = arrivo;
      this.settimana_sel = settimana;
      this.dialog_dettaglio = true;
    },

    onStampaSettimana(settimana) {
      printer.print_pdf_settimana_calendario_arrivo({ id_settimana: settimana.id });
    },
  },
};
</script>
